/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * External dependencies
 */
import type { PropsWithChildren, HTMLAttributes } from 'react';

/**
 * Internal dependencies
 */
import type { AnimationPart } from './types';

function EmptyAMPTarget({
  children,
  ...rest
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  return <div {...rest}>{children}</div>;
}

function emptyAnimationPart(): AnimationPart {
  return {
    id: '-1',
    keyframes: {},
    generatedKeyframes: {},
    WAAPIAnimation: { keyframes: {}, timings: {} },
    AMPTarget: EmptyAMPTarget,
    AMPAnimation: () => null,
  };
}

export default emptyAnimationPart;
